<template>
  <div class="about-page pt-56" id="app">
    <div class="container pd-56">
      <div class="amalfi-coast-title amalfi-coast">
        <img src="../assets/img/about/about.png" class="about-text-img" alt="">
      </div>
      <div class="noto noto-display-xl-400 gray-400 letter-spacing">关于我们</div>

      <div class="row justify-content-center ">
        <div class="col-12 col-xl-8 about-img img-container pb-24">
          <div class="sticky-img">
            <img class="w-100 parallax-img" :src="images.main" @load="handleImageLoad" @error="handleImageError">
          </div>
        </div>

        <div class="col-12 col-xl-4 pb-24">
          <div class="hover-scale-wrapper">
            <img class="w-100" src="../assets/img/about/about-img2.jpg" alt="">
          </div>
        </div>

        <div class="col-12 col-xl-4">
          <div class="hover-scale-wrapper">
            <img class="w-100" src="../assets/img/about/about-img3.jpg" alt="">
          </div>
        </div>

        <div class="col-12 col-xl-8">
          <div class="hover-scale-wrapper">
            <img class="w-100" src="../assets/img/about/about-img4.jpg" alt="">
          </div>
        </div>
      </div>

    </div>


    <!-- <section class="pt-5 pb-4 text-center container">
      <div class="reveal">
        <h1 class="amalfi-coast-title amalfi-coast">About.</h1>
        <div class="noto gray-400 letter-spacing">关于我们</div>
      </div>
    </section>

    <section class=" container">
      <div class="row justify-content-center g-4">
        <div class="col-12 col-xl-8 img-container reveal hover-scale-container img-landscape">
          <img :src="images.main" class="parallax-img" @load="handleImageLoad" @error="handleImageError"
            alt="9Plus Living Interior" />
        </div>
        <div class="col-6 col-xl-4 img-container reveal hover-scale-container img-landscape">
          <img :src="images.detail1" alt="Interior Aesthetic" @load="handleImageLoad" />
        </div>
        <div class="col-6 col-xl-4 img-container reveal hover-scale-container img-landscape">
          <img :src="images.detail2" alt="Material Detail" @load="handleImageLoad" />
        </div>
        <div class="col-12 col-xl-8 img-container reveal hover-scale-container img-landscape">
          <img :src="images.wide" alt="9Plus Workspace" @load="handleImageLoad" />
        </div>
      </div>

    </section> -->

    <!-- Content Sections -->
    <main class="container  px-6 md:px-10 max-w-6xl mx-auto pb-50  ">
      <!-- Section: Why 9PLUS -->
      <section class="reveal pd-56">
        <div class="d-flex flex-column flex-lg-row gap-5 align-items-start">

          <div class="col-lg-4 sticky-desktop" style="top:120px">
            <!-- <h2 class="text-uppercase inter inter-body-md-600 letter-spacing3 gray-400 mb-4 text-left">Introduction</h2> -->
            <h3 class="inter inter-display-sm-400  mb-0 text-left  black"><b>Why <br />Nine Plus</b></h3>
            <!-- <div style="width:50px;height:4px;background:#000"></div> -->
          </div>

          <div class="col-lg-8">
            <p class="inter inter-display-md-400-about  black text-left m-0"><b>Experience, Quality,</b> and<b> care
                <br>
              </b>in every detail.</p>
            <p class="pt-16 mb-0 pd-40 noto noto-display-md-400-about black text-left"><b>经验、品质</b>与<b>用心,</b>
              尽显于每一个细节.</p>
            <!-- <p class="mb-0 noto noto-display-lg-400 black text-left">经验、品质与用心——尽显于每一个细节.</p> -->

            <div class="inter inter-body-sm-20px gray-400 text-left">
              <p class=" m-0 pb-24 ">With its <b class="black">15 years and growing track record</b> in residential
                interior
                design. <br>
                <b class="black">Nine Plus Interior Design</b> brings together thoughtful planning designed within<br>
                refined aesthetics. <br>
                Achieved via a deep understanding of how clients truly intend to live in their homes.
              </p>
              <p class="mb-0 noto noto-body-sm-20px text-left pb-56">
                凭借在 <b class="black">住宅室内设计领域十五载</b>且不断深耕的丰富经验.<br>
                <b class="black">Nine Plus Interior Design</b> 通过深入理解客户对家居生活的真实诉求.<br>
                将周密的规划完美融入精致的美学之中.
              </p>


              <div class="pd-56">
                <div class="ratio ratio-16x9 img-container reveal">
                  <img :src="images.build" class="w-100 h-100 object-fit-cover" />
                </div>

              </div>
              <p class="m-0 ">We offer <b class="black">end-to-end design and renovation solutions,</b>
                supported by our in-house construction team. <br>
                This ensures design integrity and consistent quality from the concept stage all the way to key
                handover.
              </p>
              <br><span class="mb-0 noto noto-body-sm-20px text-left pt-24">我们提供<b
                  class="black">一站式的设计与装修解决方案，</b>并由公司自有的施工团队提供全力支持.<br>
                这确保了从概念阶段到最终交钥匙的整个过程，都能保持设计的完整性与始终如一的品质.</span>

              <div style="width:100px;height:2px;background:#E5E5EA;margin:40px 0;"></div>

              <p class="m-0">At <b class="black">Nine Plus Interior Design,</b>
                we value <b class="black">intention over trend,</b> and
                <b class="black">comfort preceding resplendence.</b>
                <br>
                Every space is designed with care to feel calm, balanced, timeless and quietly sophisticated, not
                just
                projecting beauty in the present but remaining aesthetically pleasing for years to come.
              </p>
              <p class="mb-0 noto noto-body-sm-20px text-left pt-24 pb-40">在 <b class="black">Nine Plus Interior
                  Design，</b>我们深信<b class="black">初衷胜于追逐潮流，适先于表面奢华.</b><br>每一个空间都经过精心设计，营造出平静、平衡、经典与低调精致的氛围,不仅在当下赏心悦目，更能在未来的长远岁月中历久弥新.</p>


              <div class="mt-0">
                <h4 class="playfair playfair-display-md-400 black font-italic">We don’t design for attention. </h4>
                <h4 class="pt-12 noto noto-display-md-400-about black text-left font-italic">我们不为吸引眼球而设计.</h4>

                <div style="width:50px;height:2px;background:#000;margin:40px 0"></div>
                <h4 class="playfair playfair-display-md-400 black font-italic"> We design for living. </h4>
                <h4 class="pt-12 noto noto-display-md-400-about black text-left font-italic">我们为可持续的居住体验而设计.</h4>
              </div>
            </div>
          </div>

        </div>
      </section>
      <section class="reveal pt-56">
        <div class="d-flex flex-column flex-lg-row gap-5 align-items-start">
          <div class="col-lg-8 order-2 order-lg-1">
            <p class="inter inter-display-md-400-about  black text-left m-0"><b>Design with purpose, build <br>
                with care.</b> </p>
            <p class="mb-0 pt-16 pd-40 noto noto-display-md-400-about text-left"><b>设计源于初衷，并用心筑造.</b></p>

            <div class="inter inter-body-sm-20px gray-400 text-left">
              <p class=" m-0">Our philosophy is rooted in the belief that <b class="black">good design should ease
                  daily living,</b>
                not complicate it. </p>
              <p class="mb-0 noto noto-body-sm-20px text-left pt-24 ">我们的理念根植于这信念：优秀的设计应该让日常生活更加轻松，而非让其变得繁琐.</p>
              <div style="width:100px;height:2px;background:#E5E5EA;margin:40px 0;"></div>
              <p class="m-0">For each project, Nine Plus Interior Design uphold the guiding principles of <b
                  class="black">careful listening, professional analysis, and disciplined execution.<br>
                  Layout, circulation, materials, lighting, and detailing </b>are never treated as decoration alone,
                but as
                tools to enhance comfort, function, and emotional well-<br>being.
              </p>
              <p class="mb-0 noto noto-body-sm-20px text-left pt-24 pb-56">在每一个项目中，Nine Plus Interior Design <b
                  class="black">都秉持着认真倾听、专业分析与严谨执行的指导原则. <br>
                  空间的布局、动线、材质、灯光与细节，绝不仅仅是单纯的装饰，</b>而是用来提升舒适度、实用性以及带来情感愉悦的重要载体.变得繁琐.</p>

              <div class="row pd-56">
                <div class="col-12 col-xl-6" ref="revealElements">
                  <img :src="images.texture1" class="w-100" alt="Textures" @load="handleImageLoad">
                </div>
                <div class="col-12 col-xl-6 pt-118" ref="revealElements" style="transition-delay: 0.1s">
                  <img :src="images.texture2" class="w-100" alt="Lighting" @load="handleImageLoad">
                </div>
              </div>
              <p class="m-0">From there, with our combined <b class="black">design expertise and in-house renovation capability.</b> <br>
                We then translate ideas into reality with precision and accountability. This ensures that what is
                designed is what is built, without compromise.</p>
              <p class="mb-0 noto noto-body-sm-20px text-left pt-24">
                在此基础上，结合我们<b class="black">专业的设计知识与自有的施工实力.</b> <br>
                我们以精准且负责的态度将构想化为现实. 这确保了设计蓝图与最终落地的一致性（所见即所得）,绝不妥协.</p>
              <div style="width:100px;height:2px;background:#E5E5EA;margin:40px 0;"></div>
              <p class="m-0"><b class="black">At Nine Plus Interior Design,</b>
                we create homes shaped by intention, crafted with care, and designed to stand the test of time.
              </p>
              <p class="mb-0 noto noto-body-sm-20px text-left pt-24"><b class="black">在 Nine Plus Interior
                  Design，</b>我们为您打造的家，会是源于初衷的塑造，也是倾注用心的打磨，而成果就是一个经得起时间的考验的居家环境.</p>

            </div>
          </div>
          <div class="col-lg-4 sticky-desktop order-1 order-lg-2" style="top:120px">
            <!-- <h2 class="text-uppercase inter inter-body-md-600 letter-spacing3 gray-400 mb-4 text-left text-lg-right">CORE VALUES</h2> -->
            <h3 class="inter inter-display-sm-400  mb-0 text-left text-lg-right black"><b>Our <br />Philosophy</b></h3>
            <!-- <div style="width:50px;height:4px;background:#000"></div> -->
          </div>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue';

export default {
  name: 'AboutComponent',

  setup() {
    const menuItems = ref([
      { name: 'Works', link: '#', active: false },
      { name: 'Videos', link: '#', active: false },
      { name: 'Service', link: '#', active: false },
      { name: 'About', link: '#', active: true },
      { name: 'Contact', link: '#', active: false },
    ]);

    const images = ref({
      main: require('../assets/img/about/about-img1.jpg'),
      detail1: require('../assets/img/about/about-img2.jpg'),
      detail2: require('../assets/img/about/about-img3.jpg'),
      wide: require('../assets/img/about/about-img4.jpg'),
      build: require('../assets/img/about/about-img5.jpg'),
      texture1: require('../assets/img/about/about-img6.jpg'),
      texture2: require('../assets/img/about/about-img7.jpg'),
      minimal: require('../assets/img/about/about-img1.jpg'),
    });



    const handleImageLoad = (event) => {
      event.target.classList.add('loaded');
    };

    const handleImageError = (event, fallbackSrc) => {
      event.target.src = fallbackSrc;
    };

    const handleScroll = () => {
      const scrolled = window.pageYOffset;
      const viewHeight = window.innerHeight;

      const parallaxImages = document.querySelectorAll('.parallax-img');

      parallaxImages.forEach(img => {
        const container = img.closest('.img-container');
        if (!container) return;
        const rect = container.getBoundingClientRect();

        if (rect.top < viewHeight && rect.bottom > 0) {
          const offset = (scrolled - container.offsetTop) * 0.08;
          img.style.transform = `translateY(${offset}px)  `;
        }
      });
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, { threshold: 0.1 });

      nextTick(() => {
        const elements = document.querySelectorAll('.reveal');
        elements.forEach(el => observer.observe(el));
      });

      window.addEventListener('scroll', handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll);
    });

    return {
      menuItems,
      images,
      handleImageLoad,
      handleImageError
    };
  }
};
</script>


<style>
.logo-box {
  background: black;
  color: white;
  padding: 2px 6px;
  font-weight: 900;
  border-radius: 2px;
  margin-right: 4px;
}

.hero-title {
  font-size: clamp(80px, 12vw, 160px);
  line-height: 0.8;
}

.sticky-desktop {
  position: sticky;
  top: 120px;
}

@media (max-width: 991.98px) {
  .sticky-desktop {
    position: static;
  }
}

.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: 1s cubic-bezier(.2, 1, .3, 1);
}

.reveal.visible {
  opacity: 1;
  transform: none;
}

.img-container {
  position: relative;
  overflow: hidden;
}

.img-landscape {
  min-height: 100%;
}

.row.g-4>[class*="col-"] {
  padding-left: 12px;
  padding-right: 12px;
}



.img-container img.loaded {
  opacity: 1;
}

.parallax-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
  will-change: transform;
  overflow: hidden;
}

.mosaic-grid {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 1.5rem;
}

hr {
  border-top: 1px solid #eee;
  margin: 60px 0;
}

.hover-scale-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.hover-scale-container img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;

}

.pr-24 {
  padding-right: 24px;
}

.pl-24 {
  padding-left: 24px;
}

.hover-scale-container:hover img {
  transform: scale(1.1);
  transform-origin: center center;
}

.object-fit-cover {
  object-fit: cover;
}

.hover-color:hover {
  filter: grayscale(0);
}

.grayscale {
  filter: grayscale(100%);
  transition: 0.5s;
}

.pt-56 {
  padding-top: 56px;
}

.pt-48 {
  padding-top: 4rem;
}

.pb-40 {
  padding-bottom: 4rem;
}
.pb-50 {
  padding-bottom: 50px;
}

.mb-40 {
  margin-bottom: 4rem;
}

.mb-48 {
  margin-bottom: 5rem;
}

.mb-64 {
  margin-bottom: 7rem;
}

.hover-scale-wrapper {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.hover-scale-wrapper img {
  width: 100%;
  height: 100%;
  transition: transform 0.7s ease;
}

.hover-scale-wrapper:hover img {
  transform: scale(1.1);
  transform-origin: center center;
}

.sticky-img {
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: hidden;
}

.sticky-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.7s ease;
}

.sticky-img:hover img {
  transform: scale(1.05);
}

.letter-spacing3 {
  letter-spacing: 3px;
}

.inter-body-sm-20px {
  font-size: 30px;
  line-height: 46px;
}

.intro-details-title {
  font-size: 60px;
  line-height: 62px;
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 80px;
  }

  .mosaic-grid {
    gap: 0.75rem;
  }

  .img-landscape {
    min-height: 260px;
  }

  .sticky-img {
    height: auto;
  }

  .sticky-img img {
    height: auto;
  }

  .inter-body-sm-20px {
    font-size: 16px;
    line-height: 20px;
  }

  .intro-details-title {
    font-size: 36px;
    line-height: 32px;
  }
}
</style>
